module.exports = __webpack_public_path__ + "img/more.68feb6d7.png";